import PublicLayout from '../components/layouts/PublicLayout';
import { Container, Row, Col } from 'reactstrap';
import { useState, useEffect } from 'react';
import Link from 'next/link';
import { Accordion } from 'react-bootstrap';
import axios from 'axios';
import Head from 'next/head';
import { useRouter } from 'next/router'

function AgencyFaq({meta}) {
	const [loading, setLoading] = useState(false); 
	const router = useRouter();
	
	return (
		<>
		 <Head>
			<meta name="keywords" content={meta ? meta.keywords : ''} />
			<title>{meta ? meta.title : ''}</title>
			<meta name="description" content={meta ? meta.description : ''} />
			<link rel="canonical" href={process.env.NEXT_PUBLIC_APP_URL + router.asPath} />
		</Head>
			<div className="banner_breadcrumb_section" id="professional_faq">
				<div id="spinner" className="spinner_req_review" style={{"display": loading ? "block" : "none"}}>
						<div className="lds-spinner"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
					</div>
				  <Container fluid="xl">
					<h1 className="main-heading-lg">Agency FAQs</h1>
					</Container>
				  </div>
				  <Container fluid="xl">
					  <div className="faq-sections  padding-set" >					
					  <Accordion defaultActiveKey="0">
						<Accordion.Item eventKey="0">
							<Accordion.Header>What Free features does Toprow offer?</Accordion.Header>
							<Accordion.Body>
							Toprow offers numerous free options to help service providers to attract leads, develop their online presence or prestige, and establish brand leadership.<br/>
							Here are the free features and services for service providers:
							<ul>
								<li>Company Profile Setup - It&#39;s absolutely free to get listed on Toprow and create your business profile. Yet you only need the approval to update the profile picture. Further, you can add the categories and sub-categories easily.</li>
								<li>Update Individual Dashboard - Add the overview, update the banner and work in the portfolio for a better understanding of visitors cum buyers. </li>
								<li>Clients/Agencies Reviews - The clients and other agencies can share their views on your profile after our verification process. The edit or spam options are available for false review.</li>
							</ul>
							Elaborating further, you can add or alter the overview anytime after getting the approval within 2 hours. We provide you with the facility to check how many people view your profile, reach, and visibility.
							</Accordion.Body>
						</Accordion.Item>
						<Accordion.Item eventKey="1">
							<Accordion.Header>How do I sign up for Toprow?</Accordion.Header>
							<Accordion.Body>
							Here are some easy steps to follow for signing up for Toprow:<br/>
							<b>Step 1:</b> Go to the sign-up button located at the header of Toprow&#39;s home page.<br/>
							<b>Step 2:</b> Select the agency option to create a professional or business profile.<br/>
							<b>Step 2:</b> Follow the navigation prompts to complete your profile.<br/>
							</Accordion.Body>
						</Accordion.Item>
						<Accordion.Item eventKey="2">
							<Accordion.Header>How do I add or change my profile?</Accordion.Header>
							<Accordion.Body>
								In the dashboard, you can change some profile fields anytime as per your convenience, but other options are locked for free profiles. To get access to those profiles, you need to select premium packages.<br/>
								Being a basic profile holder, you can access and update your industry&#39;s overview, work details in your portfolio, and add the social URLs in the company profile section. <br/>
								Follow the given steps to make changes to your profile:<br/>
								&gt; Log in to Toprow through your user account. (if you&#39;re facing trouble while logging in, reach our helpline (email)).<br/>
								&gt; Review the navigators on the left side of the dashboard; here, you will see numerous options; some are complimentary and others premium.<br/>
								&gt; Go to the &#39;Company Profile&#39; section to fulfill the essential details related to your business and work.<br/>
								&gt; Reevaluate the profile and edit the desired changes to the distinct fields.<br/>
								&gt; Click on &#39;View Listing&#39; to view how the viewers will see your profile.<br/>
								&gt; After completing all the changes, don&#39;t forget to click on the Save Changes to implement the alterations.<br/>
							</Accordion.Body>
						</Accordion.Item>
						<Accordion.Item eventKey="3">
							<Accordion.Header>What are the subscription features available on Toprow?</Accordion.Header>
							<Accordion.Body>
							Premium options also exist on Toprow for companies that want to upgrade their dashboard with some exceptional features.<br/> You may navigate the &#39;Subscription&#39; section to view the paid segments on the dashboard. 

							</Accordion.Body>
						</Accordion.Item>
						<Accordion.Item eventKey="4">
							<Accordion.Header>How shall I manage my dashboard?</Accordion.Header>
							<Accordion.Body>
							To manage your dashboard, you must be aware of the complementary and paid sections. Before that, we will give you a glimpse of the layout here to help you to know the options and their features.<br/>
							My Leads - Here, you can view the leads that come to your business profile.<br/>
							Reviews - View the feedback of the clients and other agencies.<br/>
							Success Tracker - View your leads here easily.<br/>
							Message Box - To communicate with the visitors or buyers.<br/>
							Company Profile - To fill the overview, add company info and URLs related to your business.<br/>
							Portfolio - Optimize your precise work portfolio here.<br/>
							Followers/ Following - Check the daily updates of followers and followings here.<br/>
							Awards - You can view your award listing here.<br/>
							Subscription - Buy the paid subscription of your choice to use and enjoy additional features.<br/>
							Logout - After use, you can easily log out of your dashboard for security.<br/>
							</Accordion.Body>
						</Accordion.Item>
						<Accordion.Item eventKey="5">
							<Accordion.Header>Do we do live communication with the visitor or buyer?</Accordion.Header>
							<Accordion.Body>
							Yes, you can directly communicate with the buyer using our message box tool. However, you need to subscribe to our basic, standard or premium packages for email and chat support services.
							<br/>
							<br/>
							Have any other questions? Check our help page or <Link href="/contact-us"><a>contact support</a></Link>.
							</Accordion.Body>
						</Accordion.Item>
						</Accordion> 
						<Row className="faq-bottom-links">
							<Col sm="6" className="text-left"><Link href={process.env.NEXT_PUBLIC_APP_URL + "/toprow-faq/"}><a className="primary-btn"><span>Toprow FAQs</span></a></Link></Col>
							<Col sm="6" className="text-right"><Link href={process.env.NEXT_PUBLIC_APP_URL + "/customer-faq/"}><a className="primary-btn"><span>Toprow Customer FAQs</span></a></Link></Col>
						</Row>
					  </div>
					
				  </Container>
		</>
	)
}

// This gets called on every request
export async function getServerSideProps({ req, res}) {
    try {
        const response = await axios.get(process.env.NEXT_PUBLIC_API_URL+'metas?path=/agency-faq', { headers: {
            "Accept": "application/json" }
        });

        return { props: { meta: response.data.data,  } }

    } catch (err) {
        const meta = false;

        return { props: { meta } };
    }
}

AgencyFaq.Layout = PublicLayout;

export default AgencyFaq
